module.exports = __webpack_public_path__ + "static/media/satisfied.00fe149f.svg";